import { EMessageTabs } from "types/Message.type";

export const ParamsKey = {
  mtab: "tab", // Aquí asignas el nombre del parámetro de mensages en el explorer
} as const;

export type ParamsValueType = {
  [ParamsKey.mtab]: keyof typeof EMessageTabs;
};
